






































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';

import { UsersList } from '@/common/Users';

// Services
import * as Sentry from '@sentry/browser';
import Staff from '@/services/Staff';
import Auth from '@/services/Auth';
import { Features } from '@/services/Features';

// Components
import Welcome from '@/components/Global/Welcome.vue';
import Loading from '@/components/Global/Loading.vue';
import Alert from '@/components/Global/Alert.vue';
import UserManagementSwitch from '@/components/Staff/UserManagement/Switch.vue';
import TextField from '@/components/Form/TextField.vue';
import SelectField from '@/components/Form/SelectField.vue';
import Search from '@/components/Staff/Payments/Search.vue';
// @ts-ignore

@Component({
	name: 'StaffUserManagement',
	components: {
		Welcome,
		Loading,
		Alert,
		UserManagementSwitch,
		TextField,
		SelectField,
		Search,
	},
})
export default class UserManagement extends Vue {
	@State('users', { namespace: 'Users' }) private users: UsersList[];

	private readonly Auth = Auth;
	private readonly Features = Features;

	private updatedUsers: Array<Required<UsersList>> = [];
	private paginate: string[] = ['updatedUsers'];
	private paginateKey: string = '';
	private error: boolean = false;
	private loading: boolean = true;

	@Watch('users', { deep: true })
	private watchUsers() {
		if (this.users.length > 0) {
			this.updatedUsers = this.users
				.filter((user: UsersList): user is Required<UsersList> => !!user.email)
				.sort((a: Required<UsersList>, b: Required<UsersList>): number => {
					// Sort by online status primarily; by email secondarily.
					let result: number = Number(b.online) - Number(a.online);
					if (result === 0) {
						result = a.email.localeCompare(b.email);
					}
					return result;
				});
		}
	}

	private async deleteUser(sub, email, index) {
		const res = confirm(`Are you sure you want to COMPLETELY delete user ${email} ?\n
		This will delete all their payments, stripe account, claims, everything`);
		if (res) {
			const checkAgain = confirm(`Are you ABSOLUTELY sure you want to completely
			 wipe out the user?`);
			if (checkAgain) {
				const delRes = await Staff.deleteUser(sub);
				if (delRes) {
					// console.log(`delete results: ${JSON.stringify(del_res, null, 2)}`);
					alert(`user removed`);
					for (let i = 0; i < this.updatedUsers.length; i++) {
						if (this.updatedUsers[i].sub === sub) {
							this.updatedUsers.splice(i, 1);
						}
					}
				} else {
					alert(`error deleting user`);
				}
			}
		}
	}

	private loadUser(sub) {
		this.$router.push({
			name: 'staffusermanagementsingle',
			params: {
				user_id: sub,
			},
		});
	}

	private async created() {
		try {
			await this.$store.dispatch('Users/getAllUsers');
			await this.$store.dispatch('Users/getIncompleteUsers');
		} catch (e) {
			Sentry.captureException(e);
			this.error = true;
		} finally {
			this.loading = false;
		}
	}
}
